import React from "react";

import { formatCellValue } from "./weeklyEACFormat";
import { DIRECT_LABOR_TOTALS_COLUMN_WIDTHS, TOTALS_GROUP_WIDTH } from "./weeklyEACColumns";
import {
  getEmployeeItdTotal,
  getEmployeeRemainingForecastTotal,
  getEmployeeGrandTotal,
} from "./weeklyEACCalculations";

// Mirrors Direct Labor's own ITD / Remaining Forecast / Total section — same column widths
// (getEmployeeItdTotal etc. are generic over any record with weeklyBuckets, not DL-specific,
// despite the name), just Unburden Cost in place of Hours.
const TOTAL_GROUPS = [
  {
    key: "itd",
    label: "ITD",
    getTotal: getEmployeeItdTotal,
    headerClass: "actualHeaderCost",
  },
  {
    key: "remainingForecast",
    label: "Remaining Forecast",
    getTotal: getEmployeeRemainingForecastTotal,
    headerClass: "forecastHeaderCost",
  },
  {
    key: "total",
    label: "Total",
    getTotal: getEmployeeGrandTotal,
    headerClass: "forecastHeaderCost",
  },
];

export default function WeeklyEACODCTotalsTable({ odcDetails, allOdcDetails }) {
  return (
    <table className="thirdTableFin weeklyEac" cellPadding={0} cellSpacing={0}>
      <thead>
        <tr>
          {TOTAL_GROUPS.map((group) => (
            <th
              key={group.key}
              colSpan={2}
              className="centerAlignedHeaderLeftBorder"
              style={{ minWidth: TOTALS_GROUP_WIDTH, maxWidth: TOTALS_GROUP_WIDTH }}
            >
              {group.label}
            </th>
          ))}
        </tr>
        <tr>
          {TOTAL_GROUPS.map((group) => (
            <React.Fragment key={group.key}>
              <th
                className={group.headerClass}
                style={{
                  minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                  maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                }}
              >
                Total Unburden Cost
              </th>
              <th
                className={group.headerClass}
                style={{
                  minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                  maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                }}
              >
                Total Burden Cost
              </th>
            </React.Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        {odcDetails.map((odc) => (
          <tr key={odc.odcId}>
            {TOTAL_GROUPS.map((group) => (
              <React.Fragment key={group.key}>
                <td
                  style={{
                    minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                    maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                    paddingLeft: "4px",
                    borderLeft: "1px solid #ccc",
                  }}
                  title={formatCellValue(group.getTotal(odc, "unburdenCost"), "currency")}
                >
                  {formatCellValue(group.getTotal(odc, "unburdenCost"), "currency")}
                </td>
                <td
                  style={{
                    minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                    maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                  }}
                  title={formatCellValue(group.getTotal(odc, "burdenCost"), "currency")}
                >
                  {formatCellValue(group.getTotal(odc, "burdenCost"), "currency")}
                </td>
              </React.Fragment>
            ))}
          </tr>
        ))}
        <tr className="totalRow">
          {TOTAL_GROUPS.map((group) => {
            const totalUnburdenCost = allOdcDetails.reduce(
              (sum, odc) => sum + group.getTotal(odc, "unburdenCost"),
              0,
            );
            const totalBurdenCost = allOdcDetails.reduce(
              (sum, odc) => sum + group.getTotal(odc, "burdenCost"),
              0,
            );
            return (
              <React.Fragment key={group.key}>
                <td
                  style={{
                    minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                    maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                    paddingLeft: "4px",
                    borderLeft: "1px solid #ccc",
                  }}
                  title={formatCellValue(totalUnburdenCost, "currency")}
                >
                  {formatCellValue(totalUnburdenCost, "currency")}
                </td>
                <td
                  style={{
                    minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                    maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                  }}
                  title={formatCellValue(totalBurdenCost, "currency")}
                >
                  {formatCellValue(totalBurdenCost, "currency")}
                </td>
              </React.Fragment>
            );
          })}
        </tr>
      </tbody>
    </table>
  );
}
